
export const isPanoramaEnabled = ({ isPanoramaLocked }) => ({
  type: 'IS_PANORAMA_LOCKED',
  isPanoramaLocked
})
